import Vue from 'vue'
import Icon from 'vue-svg-icon/Icon'

import App from './scripts/application'

// Globals components
import './scripts/mixins/core-event-hub'

// Start application
/* eslint-disable no-new */
Vue.component('icon', Icon)
new Vue(App).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js